import { returnsDefaultDiscountByWeightSchema } from "@redotech/redo-fulfillment-rate-table-common/rate-table";
import * as z from "zod";

export const getDefaultDiscountTables = {
  name: "getDefaultDiscountTables" as const,
  input: z.object({}),
  output: z.object({
    discountTables: z.array(returnsDefaultDiscountByWeightSchema),
  }),
};
